import { withNamespaces } from "react-i18next";
import ReactApexChart from "react-apexcharts";
import { Card, CardBody, CardTitle } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from "src/common/constants";

const DocumentationChangeTrend = ({ t, trend = {} }) => {
    const dateUtils = new DateUtils();
    const seriesRows = trend.series || [];
    const categories = seriesRows.map((row) =>
        dateUtils.convertDateToDate(row.date, INTERNATIONAL_DATE_FORMAT)
    );
    const options = {
        chart: {
            toolbar: { show: false },
            zoom: { enabled: false }
        },
        colors: ["#556ee6", "#fcb92c", "#34c38f"],
        dataLabels: { enabled: false },
        stroke: {
            width: [3, 3, 3],
            curve: "smooth",
            dashArray: [0, 8, 5]
        },
        markers: { size: 0 },
        xaxis: {
            categories
        },
        yaxis: {
            min: 0,
            forceNiceScale: true
        },
        legend: {
            position: "bottom",
            horizontalAlign: "left",
            markers: { radius: 12 }
        },
        grid: { borderColor: "#f1f1f1" }
    };
    const series = [
        {
            name: t("Added"),
            data: seriesRows.map((row) => Number(row.added || 0))
        },
        {
            name: t("Updated"),
            data: seriesRows.map((row) => Number(row.updated || 0))
        },
        {
            name: t("Removed"),
            data: seriesRows.map((row) => Number(row.removed || 0))
        }
    ];

    return (
        <Card className="overview-sustainability-card h-100 mb-0">
            <CardBody>
                <CardTitle className="overview-section-title mb-3">
                    {t("Documentation change trend")}
                </CardTitle>
                <ReactApexChart
                    options={options}
                    series={series}
                    type="line"
                    height={280}
                />
                {trend.reliability?.completeForRequestedPeriod === false && (
                    <small className="text-muted d-block mt-2">
                        {t("Tracking since")}{" "}
                        {dateUtils.convertDateToDate(
                            trend.reliability?.trackingSince,
                            INTERNATIONAL_DATE_FORMAT
                        )}
                    </small>
                )}
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(DocumentationChangeTrend);
